<template>
  <v-dialog
    max-width="600"
    :value="true"
    persistent>
    <v-card>
      <v-card-title>
        <h2>{{ editing ? 'Edit' : 'New' }} Review</h2>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          @submit.prevent="submit">
          <label>Client Name</label>
          <v-text-field
            v-model="review.clientName"
            label="Client Name"
            solo
            :rules="validateName"
            validate-on-blur />

          <label>Score</label>
          <StarRating
            class="mb-2"
            justify="flex-start"
            :rating="review.score"
            @change="review.score = $event.ratingValue" />

          <label>Review Text</label>
          <v-textarea
            v-model="review.description"
            solo
            required />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <button
          class="default-btn blue"
          :disabled="saving"
          @click="submit">
          <span>Create</span>
          <v-icon v-if="saving" right>
            mdi-loading mdi-spin
          </v-icon>
        </button>

        <button
          class="default-btn text"
          @click="$emit('cancel')">
          Cancel
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formMixin } from '@/mixins'

export default {
  name: 'AdminCreateEditProviderReview',
  mixins: [formMixin],

  props: {
    originalReview: {
      type: Object,
      default: () => ({}),
    },
    editing: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    review: {},
  }),

  created () {
    this.review = Object.assign({}, this.originalReview)
  },

  methods: {
    submit () {
      if (!this.$refs.form.validate()) return

      this.$emit('submit', this.review)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
